import { useIntl } from 'react-intl';
import { useHistory } from 'react-router-dom';
import i18nMessages from './SideMenuTranslations';
import { AccountType } from '../../../shared/Constants';

const AssessmentsSideMenuBuilder = (accountId, accountType) => {
  const { formatMessage } = useIntl();
  const history = useHistory();

  const buildAssessmentTabs = () => {
    const listAssessments = {
      label: formatMessage(i18nMessages.listAssessments),
      icon: 'pi pi-list',
      command: () => {
        const url = `/accounts/${accountId}/assessments`;
        history.push(url);
      },
    };

    return listAssessments;
  };

  const buildJobProfileTabs = () => {
    const jobProfiles = {
      label: formatMessage(i18nMessages.jobProfiles),
      icon: 'pi pi-globe',
      items: [
        {
          label: formatMessage(i18nMessages.listJobProfiles),
          icon: 'pi pi-list',
          command: () => {
            const url = `/accounts/${accountId}/job-profiles`;
            history.push(url);
          },
        },
        {
          label: formatMessage(i18nMessages.addJobProfile),
          icon: 'fa fa-fw fa-plus',
          command: () => {
            const url = `/accounts/${accountId}/job-profiles/new`;
            history.push(url);
          },

        },
      ],
    };

    return jobProfiles;
  };

  const buildSuperLinkTabs = () => {
    const superLinkItems = {
      label: formatMessage(i18nMessages.superLink),
      icon: 'pi pi-share-alt',
      items: [
        {
          label: formatMessage(i18nMessages.listSuperLinks),
          icon: 'pi pi-list',
          command: () => {
            const url = `/accounts/${accountId}/super-links`;
            history.push(url);
          },
        },
        {
          label: formatMessage(i18nMessages.addSuperLink),
          icon: 'pi pi-plus-circle',
          command: () => {
            const url = `/accounts/${accountId}/super-links/new`;
            history.push(url);
          },
        },
      ],
    };

    return superLinkItems;
  };

  const buildAssessmentTemplateTabs = () => {
    const assessmentTemplates = {
      label: formatMessage(i18nMessages.assessmentTemplates),
      icon: 'pi pi-folder-open',
      items: [
        {
          label: formatMessage(i18nMessages.listAssessmentTemplates),
          icon: 'pi pi-list',
          command: () => {
            const url = `/accounts/${accountId}/assessments/templates`;
            history.push(url);
          },
        },
        {
          label: formatMessage(i18nMessages.addAssessmentTemplate),
          icon: 'pi pi-plus-circle',
          command: () => {
            const url = `/accounts/${accountId}/assessments/templates/new`;
            history.push(url);
          },
        },
      ],
    };

    return assessmentTemplates;
  };

  const buildDataExportTabs = () => {
    const dataExport = {
      label: formatMessage(i18nMessages.dataExport),
      icon: 'pi pi-download',
      command: () => {
        const url = `/accounts/${accountId}/export`;
        history.push(url);
      },
    };

    return dataExport;
  };

  const buildAssessmentAnalysisTabs = () => {
    const assessmentAnalysis = {
      label: formatMessage(i18nMessages.assessmentAnalysis),
      icon: 'pi pi-calendar-plus',
      items: [
        {
          label: formatMessage(i18nMessages.listTeamReports),
          icon: 'pi pi-list',
          command: () => {
            const url = `/accounts/${accountId}/team-reports`;
            history.push(url);
          },
        },
        {
          label: formatMessage(i18nMessages.addTeamReport),
          icon: 'pi pi-plus-circle',
          command: () => {
            const url = `/accounts/${accountId}/team-reports/new`;
            history.push(url);
          },
        },
      ],
    };

    return assessmentAnalysis;
  };

  const buildAssessmentMenu = () => {
    const assessmentItems = [];

    const listAssessments = buildAssessmentTabs();
    const superLinkItems = buildSuperLinkTabs();
    const jobProfiles = buildJobProfileTabs();
    const assessmentTemplates = buildAssessmentTemplateTabs();
    const dataExport = buildDataExportTabs();
    const assessmentAnalysis = buildAssessmentAnalysisTabs();

    if (accountType === AccountType.GSC || accountType === AccountType.GP) {
      assessmentItems.push(listAssessments);
      assessmentItems.push(jobProfiles);
      assessmentItems.push(assessmentTemplates);
      assessmentItems.push(dataExport);
      assessmentItems.push(assessmentAnalysis);
    } else {
      assessmentItems.push(listAssessments);
      assessmentItems.push(superLinkItems);
      assessmentItems.push(jobProfiles);
      assessmentItems.push(assessmentTemplates);
      assessmentItems.push(dataExport);
      assessmentItems.push(assessmentAnalysis);
    }

    const assessments = {
      label: formatMessage(i18nMessages.assessments),
      icon: 'pi pi-calendar',
      items: assessmentItems,
    };

    return assessments;
  };

  return {
    buildAssessmentMenu,
  };
};

export default AssessmentsSideMenuBuilder;
